// extracted by mini-css-extract-plugin
export var actions = "_g-0";
export var actionsContainer = "_g-7";
export var border = "_g-1";
export var childFullHeight = "_g-g";
export var collapse = "_g-2";
export var content = "_g-b";
export var contentChild = "_g-f";
export var fullscreen = "_g-d";
export var hasLeftRadius = "_g-l";
export var headerContainer = "_g-3";
export var headerRow = "_g-5";
export var hidePadding = "_g-c";
export var navCollapsedGap = "_g-m";
export var noScrollX = "_g-n";
export var noScrollY = "_g-o";
export var noTopPadding = "_g-j";
export var optOutTopPadding = "_g-e";
export var pageMain = "_g-k";
export var pageOuter = "_g-h";
export var pagePadding = "_g-8";
export var pageScroll = "_g-9";
export var profile = "_g-p";
export var profileContainer = "_g-q";
export var profileImage = "_g-r";
export var profileMain = "_g-s";
export var profileSubtitle = "_g-u";
export var profileTitle = "_g-t";
export var settingsSurface = "_g-a";
export var showLeftPadding = "_g-i";
export var tabsPortalSlot = "_g-6";
export var tabsWrapper = "_g-4";
export var title = "_g-v";